import { MenuInformasi } from 'master-data/menu';
import React from 'react'
import { Link } from 'react-router-dom';

export const Section4 = () => {
    return (
        <section className="home_section4">
            <div className="container">
            <div className="row">
                <div className="col-md-12">
                <div id="blockid_3f9d058" className="block-section jl-main-block">
                    <div className="jl_grid_wrap_f jl_clear_at g_4col">
                    <div className="jl-roww content-inner jl-col3 jl-col-row">
                        <div className="jl_sec_title">
                        <h3 className="jl_title_c"><span>Informasi | Dinas Pendidikan</span></h3>
                        <p>Informasi yang ada pada Dinas Pendidikan</p>
                        </div>
                        {
                            MenuInformasi && MenuInformasi.map((item, index) => {
                                return (
                                    <div className="jl-grid-cols">
                                        <div className="p-wraper post-2691">
                                            <div className="jl_grid_w">
                                            <div className="jl_img_box jl_radus_e">
                                                <Link to={item.link}>
                                                    <img width={500} height={350} src={item.image} className="attachment-sprasa_slider_grid_small size-sprasa_slider_grid_small wp-post-image" alt="" loading="lazy" />
                                                </Link>
                                                {/* <span className="jl_f_cat"><a className="post-category-color-text" style={{background: '#379e63'}} href="#">{item.name}</a></span> */}
                                            </div>
                                            <div className="text-box">
                                                <h3><a href="#">{item.name}</a></h3>
                                                <p>{item.description}</p>
                                            </div>
                                            </div>
                                        </div>
                                        </div>
                                )
                            })
                        }
                    </div>
                    </div>
                </div>
                </div>
            </div>
            </div>
        </section>
    )
};